if (!customElements.get('waltons-sale-clock')) {
  customElements.define('waltons-sale-clock', class extends HTMLElement {
    connectedCallback() {
      clearInterval(this.interval);
      this.deadline = Date.parse(this.dataset.expires);
      if (!Number.isFinite(this.deadline)) return;
      this.tick();
      if (this.deadline > Date.now()) this.interval = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() { clearInterval(this.interval); }
    tick() {
      const remaining = Math.max(0, Math.floor((this.deadline - Date.now()) / 1000));
      this.querySelector('.wbf__date').hidden = true;
      this.querySelector('.wbf__digits').hidden = remaining === 0;
      this.querySelector('.wbf__expired').hidden = remaining > 0;
      if (!remaining) { clearInterval(this.interval); return; }
      const values = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60 };
      for (const [unit, value] of Object.entries(values)) this.querySelector(`[data-unit="${unit}"]`).textContent = String(value).padStart(2, '0');
    }
  });
}

if (!customElements.get('waltons-sale-ribbon')) {
  customElements.define('waltons-sale-ribbon', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.wbf__ribbon-control');
      if (!this.button) return;
      this.toggle = () => {
        const paused = this.toggleAttribute('data-paused');
        const label = paused ? 'Resume banner scrolling' : 'Pause banner scrolling';
        this.button.setAttribute('aria-label', label);
        this.button.setAttribute('title', label);
      };
      this.button.addEventListener('click', this.toggle);
      this.button.hidden = false;
      this.setAttribute('data-ready', '');
    }
    disconnectedCallback() {
      this.button?.removeEventListener('click', this.toggle);
    }
  });
}

if (!customElements.get('waltons-sale-gallery')) {
  customElements.define('waltons-sale-gallery', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('.wbf__slide')];
      if (this.slides.length < 2) return;
      this.index = this.slides.findIndex(slide => slide.classList.contains('is-active'));
      this.controls = this.querySelector('.wbf__gallery-controls');
      this.pauseButton = this.querySelector('[data-gallery-pause]');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.controls.hidden = false;
      this.querySelector('[data-next]').addEventListener('click', () => this.manualMove(1), options);
      this.querySelector('[data-previous]').addEventListener('click', () => this.manualMove(-1), options);
      this.pauseButton.addEventListener('click', () => this.setPaused(!this.paused), options);
      this.updateMotion = () => { this.pauseButton.hidden = this.motion.matches; };
      // Safari before 14 only has the older addListener on media queries.
      if (this.motion.addEventListener) this.motion.addEventListener('change', this.updateMotion);
      else if (this.motion.addListener) this.motion.addListener(this.updateMotion);
      this.updateMotion();
      this.inView = true;
      // Pausing off screen needs IntersectionObserver, which some in-app
      // browsers lack; without it the photographs simply keep rotating.
      if (typeof window.IntersectionObserver !== 'undefined') {
        this.observer = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; });
        this.observer.observe(this);
      }
      this.interval = setInterval(() => {
        if (!this.paused && !this.motion.matches && !document.hidden && this.inView && !this.matches(':hover, :focus-within')) this.move(1);
      }, 6000);
    }
    setPaused(paused) {
      this.paused = paused;
      this.pauseButton.setAttribute('aria-label', paused ? 'Resume photographs' : 'Pause photographs');
      this.pauseButton.querySelector('path').setAttribute('d', paused ? 'm5 2 9 6-9 6z' : 'M4 3h3v10H4zM9 3h3v10H9z');
    }
    manualMove(direction) {
      this.setPaused(true);
      this.move(direction);
    }
    async move(direction) {
      if (this.moving) return;
      this.moving = true;
      const next = (this.index + direction + this.slides.length) % this.slides.length;
      const image = this.slides[next].querySelector('img');
      try {
        // Keep the current photograph visible until the next is ready.
        await image.decode();
        if (!this.isConnected) return;
        this.slides[this.index].classList.remove('is-active');
        this.slides[this.index].setAttribute('aria-hidden', 'true');
        this.slides[next].classList.add('is-active');
        this.slides[next].removeAttribute('aria-hidden');
        this.index = next;
        this.querySelector('[data-counter]').textContent = `${next + 1} / ${this.slides.length}`;
      } catch {
        // A missing image must never replace a loaded photograph.
      } finally { this.moving = false; }
    }
    disconnectedCallback() {
      clearInterval(this.interval);
      this.events?.abort();
      this.observer?.disconnect();
      if (this.motion?.removeEventListener) this.motion.removeEventListener('change', this.updateMotion);
      else if (this.motion?.removeListener) this.motion.removeListener(this.updateMotion);
    }
  });
}
